/**
 * A photo's preview: a small JPEG stored beside the photo and sent with its upload request, so
 * the message payload carries it to every reader (maper-server chat/serializers.py).
 */

/** The server's cap on a preview (chat/limits.py MAX_PREVIEW_BYTES); a larger one is left out. */
export const MAX_PREVIEW_BYTES = 8 * 1024;

/**
 * Where a photo's preview is stored: `<name>.jpg` has `<name>.preview.jpg` beside it. Android's
 * PhotoPreparer writes it there and its MediaUpload reads it from there.
 */
export function previewPathFor(path: string): string {
    return `${path.replace(/\.[^./]*$/, '')}.preview.jpg`;
}

export function encodeBase64(bytes: Uint8Array): string {
    const chunks: string[] = [];
    const chunkSize = 0x8000;
    for (let offset = 0; offset < bytes.byteLength; offset += chunkSize) {
        chunks.push(String.fromCharCode(...bytes.subarray(offset, offset + chunkSize)));
    }
    return btoa(chunks.join(''));
}
